var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediaIcon13(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37,
    height: 41,
    viewBox: "0 0 37 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1668",
    "data-name": "Rectangle 1668",
    width: 37,
    height: 41,
    transform: "translate(-4 -3)",
    fill: "#ff9ee0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4666",
    "data-name": "Group 4666",
    transform: "translate(4 3.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4665",
    "data-name": "Group 4665",
    transform: "translate(0 -0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14064",
    "data-name": "Path 14064",
    d: "M27.524,11.893a4.15,4.15,0,0,0-2.383.749,4.171,4.171,0,0,0-5.962-2.067v-6.4a4.173,4.173,0,1,0-8.346,0V19.256L9.348,16.685A4.173,4.173,0,0,0,2.1,20.818c5.039,10.627,8.386,15.069,16.037,15.069A13.577,13.577,0,0,0,31.7,22.325V16.066a4.178,4.178,0,0,0-4.173-4.173M29.61,22.325A11.489,11.489,0,0,1,18.135,33.8c-6.018,0-8.931-2.86-14.169-13.912-.012-.026-.025-.051-.04-.076a2.088,2.088,0,0,1,1.8-3.132,2.1,2.1,0,0,1,.544.072,2.074,2.074,0,0,1,1.268.974l3.431,5.943a1.043,1.043,0,0,0,1.947-.522V4.173a2.086,2.086,0,1,1,4.173,0V14.814a1.043,1.043,0,0,0,2.086,0v-.626a2.086,2.086,0,1,1,4.173,0v1.878a1.043,1.043,0,1,0,2.086,0,2.086,2.086,0,1,1,4.173,0Z",
    transform: "translate(-1.232 0.001)",
    fill: "#ff9ee0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14065",
    "data-name": "Path 14065",
    d: "M3.343,10.883h0A.784.784,0,0,0,3.9,9.544L2.673,8.321H7.367a.783.783,0,1,0,0-1.566H2.673L3.892,5.536a.781.781,0,0,0,.236-.559A.772.772,0,0,0,3.9,4.428a.78.78,0,0,0-1.113-.005L.231,6.981a.741.741,0,0,0-.174.265.77.77,0,0,0,0,.575.735.735,0,0,0,.174.27L2.787,10.65a.774.774,0,0,0,.556.233",
    transform: "translate(-2 -3.317)",
    fill: "#ff9ee0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14066",
    "data-name": "Path 14066",
    d: "M93.68,8.321h4.694L97.155,9.539a.782.782,0,0,0-.236.559.784.784,0,0,0,1.339.554l2.559-2.559a.742.742,0,0,0,.173-.265.773.773,0,0,0,0-.576.74.74,0,0,0-.174-.269L98.26,4.425a.784.784,0,1,0-1.11,1.106l1.224,1.223H93.68a.783.783,0,1,0,0,1.566",
    transform: "translate(-71.514 -3.317)",
    fill: "#ff9ee0"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaIcon13);
export default __webpack_public_path__ + "static/media/media_icon13.fa635b50a4c6d8fc24eef39804e5d226.svg";
export { ForwardRef as ReactComponent };